import usePayment, { PaymentMethods } from "hooks/usePayment";
import { IInstallmentItem } from "models";
import { useMemo } from "react";
import {
  EnumTypeDebit,
  MappedDebitsToGetInstallments,
} from "services/CreditCard";
import { cleanMoneyMask } from "utils";
import { mapInstallments } from "../utils/constants";

const NUMBER_MULTIPLE_PAYMENT = 2;
const DEFAULT_INSTALLMENT_NUMBER = 1;

interface useInstallmentsReturn {
  debits: MappedDebitsToGetInstallments;
  chargeMethods?: any[]
  handleInstallmentInfo: (payment: PaymentMethods, index: number) => IInstallmentItem;
}

export function useInstallments(): useInstallmentsReturn {
  const { paymentMethods, dataPaymentBillet, installments } = usePayment();

    const handleInstallmentInfo = (payment: PaymentMethods, index: number): IInstallmentItem => {
      let installment;
      const { typeMethod } = payment;
  
      if (typeMethod === "credit") {
        installment = payment.installments;
      }
  
      if (installments?.multiple?.options?.[index]) {
        return installments.multiple.options[index];
      }
  
      const installmentIndex = (installment ?? 1) - 1;
  
      return mapInstallments[typeMethod](installments, installmentIndex);
    };

  const debits = useMemo(() => {
    return [
      ...dataPaymentBillet.billets.map((billet) => ({
        type: EnumTypeDebit.BILLET,
        id_bill: billet.id_bill,
      })),
      ...dataPaymentBillet.debits.filter(debit => !debit?.redirect_to_be_paid).map((debit) => ({
        type: EnumTypeDebit.CAR_DEBIT,
        id_debit: debit.id_debit,
      })),
      ...dataPaymentBillet.pix.map(({ id_pix }) => ({
        type: EnumTypeDebit.PIX,
        id_pix,
      })),
    ]
  }, [dataPaymentBillet]);

  const chargeMethods = useMemo(() => {
    if (paymentMethods.length === NUMBER_MULTIPLE_PAYMENT) {
      return paymentMethods.map((method: PaymentMethods) => ({
        ...(method?.typeMethod === "credit" && {
          type: "CREDIT_CARD",
          installment_number: +method.installments,
          original_amount: cleanMoneyMask(method.value),
        }),
        ...(method?.typeMethod === "debit" && {
          type: "DEBIT_CARD",
          installment_number: DEFAULT_INSTALLMENT_NUMBER,
          original_amount: cleanMoneyMask(method.value),
        }),
        ...(method?.typeMethod === "pix" && {
          type: "PIX",
          installment_number: DEFAULT_INSTALLMENT_NUMBER,
          original_amount: cleanMoneyMask(method.value),
        }),
      }));
    }
  }, [paymentMethods]);

  return {
    handleInstallmentInfo,
    debits: debits as unknown as MappedDebitsToGetInstallments,
    chargeMethods,
  };
}
